module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEFISH.3abe98e5.png";